<ng-progress #progressBar ngProgressHttp></ng-progress>
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<p-blockUI [blocked]="blockedDocument">
  <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
</p-blockUI>
<router-outlet></router-outlet>
